var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('zm-button',{staticClass:"opc-btn-continue",class:{
    'opc-modal': _vm.isModal
  },attrs:{"data-testid":"checkout-button-394","type":"primary","round":"","size":"large","loading":_vm.isLoading,"disabled":_vm.disabled},on:{"click":_vm.next}},[_vm._v(" "+_vm._s(_vm.$t('billing.continue'))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }